import React, { FC } from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import HeadTable from './components/header';
// import { AccountingType } from 'v2-types/order';
import { Column } from 'types/common';
import { Paper, Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import RowTable from './components/item';
import useStyles from './style';

type ColumnSort = { [key: string]: 'asc' | 'desc' };

type virtualizedTableProps = {
	dataSet: any[];
	onClickItem?: (row?: any, column?: Column, index?: number) => void;
	columns: { [key: string]: Column };
  };

const VirtuosoTableRow = (props: any) => <TableRow {...props} />;

const TableComponents = {
  Scroller: React.forwardRef<HTMLDivElement>((props, ref) => (<TableContainer component={Paper} {...props} ref={ref} />)) as any,
  Table: (props) => {
    const classes = useStyles();
    return (<Table {...props} className={classes.table} style={{ borderCollapse: 'separate' }} />);
  },
  TableHead,
  TableRow: VirtuosoTableRow,
  TableBody: React.forwardRef<HTMLDivElement>((props, ref) => <TableBody {...props as any} ref={ref} />),
};
const VirtualizedTable:FC<virtualizedTableProps> = ({
  columns,
  dataSet,
  onClickItem,
}) => {
  const columnsv2 = Object.values(columns);
  const { innerHeight: height } = window;
  return (
    <TableVirtuoso
      style={{ height }}
      data={dataSet}
      components={TableComponents as any}
      fixedHeaderContent={() => ((<HeadTable columns={columnsv2 || []} />))}
      overscan={10}
      itemContent={(index, data) => (
        <RowTable
          data={data}
          indexRow={index}
          columns={columnsv2}
          onClickItem={onClickItem}
        />
      )}
    />
  );
};

export default VirtualizedTable;
/*

*/
